import { Injectable } from '@angular/core';

export interface NotificationSource {
  id?: string;
  fullName?: string;
  fullNativeName?: string;
  firstName?: string;
  lastName?: string;
}

export interface ClothingNotificationMessageParams {
  employeeName?: string;
  catalogItemName?: string;
  catalogItemNames?: string[];
  quantity?: number;
  activeUntil?: string;
  remainingWorkingDays?: number;
  employeeReason?: string;
  headName?: string;
  headComment?: string;
  penaltyAmount?: number;
  penaltyCurrency?: string;
  [key: string]: string | number | string[];
}

export interface AppNotification {
  id: string;
  category?: string;
  type?: string;
  notificationMarker?: string;
  clothingNotificationType?: string;
  userId?: string;
  employeeId?: string;
  targetUserId?: string;
  profileUserId?: string;
  employeeUserId?: string;
  catalogItemId?: string;
  requestId?: string;
  lossCaseId?: string;
  positionId?: string;
  description?: string;
  messageKey?: string;
  messageParams?: ClothingNotificationMessageParams;
  link?: string;
  timestamp?: string;
  create?: string;
  status?: string;
  viewed?: boolean;
  actionRequired?: boolean;
  actionResolved?: boolean;
  payloadVersion?: number;
  user?: {
    id?: string;
  };
  source?: NotificationSource;
}

const CLOTHING_NOTIFICATION_MARKER = 'CLOTHING';
const CLOTHING_NOTIFICATION_CATEGORY = 'CLOTHING';
const GENERAL_NOTIFICATION_CATEGORY = 'NOTIFICATION_GENERAL';
const PROFILE_ROUTE = '/dashboard/profile';

@Injectable()
export class ClothingNotificationRoutingService {
  isClothingCategory(category: string): boolean {
    return category === CLOTHING_NOTIFICATION_CATEGORY;
  }

  isClothingNotification(notification: AppNotification): boolean {
    if (!notification) {
      return false;
    }
    if (notification.notificationMarker === CLOTHING_NOTIFICATION_MARKER) {
      return true;
    }
    return this.isClothingCategory(notification.category);
  }

  resolveViewCategory(notification: AppNotification): string {
    if (notification && notification.notificationMarker === CLOTHING_NOTIFICATION_MARKER) {
      return GENERAL_NOTIFICATION_CATEGORY;
    }
    return CLOTHING_NOTIFICATION_CATEGORY;
  }

  resolveProfileRoute(notification: AppNotification, currentUserId: string): string {
    var profileUserId = this.resolveProfileUserId(notification);

    if (!profileUserId || profileUserId === currentUserId) {
      return PROFILE_ROUTE;
    }
    return PROFILE_ROUTE + '/' + profileUserId;
  }

  private resolveProfileUserId(notification: AppNotification): string {
    var employeeUserId = this.resolveEmployeeUserId(notification);

    if (employeeUserId) {
      return employeeUserId;
    }
    return this.resolveDirectUserId(notification);
  }

  private resolveDirectUserId(notification: AppNotification): string {
    if (notification && notification.user && notification.user.id) {
      return notification.user.id;
    }
    if (notification && notification.userId) {
      return notification.userId;
    }
    if (notification && notification.targetUserId) {
      return notification.targetUserId;
    }
    return '';
  }

  private resolveEmployeeUserId(notification: AppNotification): string {
    if (notification && notification.employeeId) {
      return notification.employeeId;
    }
    if (notification && notification.profileUserId) {
      return notification.profileUserId;
    }
    if (notification && notification.employeeUserId) {
      return notification.employeeUserId;
    }
    return '';
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/clothing-notification-routing.service.ts